<template>
<main id="maincontent">
    <div v-if="active" class="card">        
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <Error ref="error" />
        <div class="card-body" @keyup.enter="clickAction">
            <PageHeader :title="flow" variant="small" class="mb-4" />
            <SSN ref="ssn" :labels="screenData.text" name="taxId" v-model:is-disabled="tinDisabled" @set-tax-id="setTaxId"></SSN>
            <div v-if="!init" class="col-12 px-0">
                <AccountNumber ref="accountNumber" :labels="screenData.text" name="accountNumber" v-model:required="accountRequired" @set-account-number="setAccountNumber"></AccountNumber>
                <DateOfBirth :labels="screenData.text" v-model:required="dateOfBirthRequired" @set-date-of-birth="setDateOfBirth"></DateOfBirth>
                <Password :label="screenData.text.password" v-if="passwordRequired" @update-password="setPassword"></Password>
            </div>
            <ActionList :actions="screenData.actions" @validate-pii="validate" @validate-password-pii="validatePasswordPii" @validate-login-pii="validateLoginPii" @validate-username-pii="validateUsernamePii" @cancel-pii="cancel"></ActionList>
        </div>
    </div>
</main>
</template>

<script>
    import { nextTick } from 'vue'
    import Error from '../entities/Error.vue';
    import SSN from '../entities/SSN.vue';
    import AccountNumber from '../entities/AccountNumber.vue';
    import DateOfBirth from '../entities/DateOfBirth.vue';
    import Password from '../entities/Password.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';
    //import {goToIndexPage} from '../../../../src/utility/miscellaneous'

    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';
    
    export default {
        name: "ChallengePII",

        components: {
            Error,
            SSN,
            AccountNumber,
            DateOfBirth,
            Password,
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object,
            profileCallerId: String
        },

        data: function() {
            return {
                flow: "",
                init: true,
                validateAPI: "",
                nextStep: "",
                active: false,
                tinType: "",
                taxIdNumber: "",
                accountRequired: false,
                dateOfBirthRequired: false,
                tinDisabled: false,
                accountNumber: "",
                dateOfBirth: "",
                stateToken: "",
                nextAPI: "",
                skipCollection: false,
                username: "",
                isValid: false,
                passwordRequired: false,
                password: "",
                skipMfaEnrollment: false
            }
        },

        methods: {
            //goToIndexPage,
            show: function(data) {
                this.flow = data.flow;
                this.validateAPI = data.validateAPI;
                this.nextStep = data.nextStep;

                if (data.username !== undefined) {
                    this.username = data.username;
                }

                if (data.skipCollection !== undefined) {
                    this.skipCollection = data.skipCollection;
                }

                if (data.stateToken !== undefined) {
                    this.stateToken = data.stateToken;
                }

                if (data.tinType !== undefined) {
                    this.tinType = data.tinType;
                }

                if (data.accountRequired !== undefined) {
                    this.accountRequired = data.accountRequired;
                }

                if (data.dateOfBirthRequired !== undefined) {
                    this.dateOfBirthRequired = data.dateOfBirthRequired;
                }

                if (data.skipMfaEnrollment !== undefined) {
                    this.skipMfaEnrollment = data.skipMfaEnrollment;
                }

                this.active = true;
                nextTick(function() {
                    this.init = data.init;
                    this.clear();
                    if (this.init) {
                        this.$emitter.emit('disable', 'validate-pii');
                    }
                    
                    if (data.error !== undefined) {
                        this.$refs["error"].display(data.error.errorCode, data.error.errorMessage, data.error.errorType);
                    }

                    this.$emitter.emit('disable', this.nextStep);
                }.bind(this));
            },

            hide: function() {
                this.active = false;
                this.init = true;
                this.isValid = false;
                this.passwordRequired = false;
            },

            clear: function() {
                var ssnRef = this.$refs.ssn;
                ssnRef && ssnRef.clear();
                var accountNumberRef = this.$refs.accountNumber;
                accountNumberRef && accountNumberRef.clear();
                this.dateOfBirth = "";
                this.tinDisabled = false;
            },

            clickAction: function() {
                if (this.isValid) {
                    if (this.init) {
                        this.validate();
                    }
                    else {
                        this.routeNextStep();
                    }
                }
            },

            validate: function() {
                this.$emitter.emit('start-loading','validate-pii');
                var data = {
                    taxId: this.taxIdNumber,
                };

                this.$axios.post(this.validateAPI, data).then(function(response) {
                    if (response.data.success) {
                        this.tinDisabled = true;
                        this.stateToken = response.data.data.stateToken;
                        var factor = response.data.data._embedded.factors[0];

                        for (var key in factor.policy.complexity) {
                            this[key] = factor.policy.complexity[key];
                        }

                        if (this.nextStep === "validate-username-pii" && this.dateOfBirthRequired === true && this.accountRequired === false) {
                            this.passwordRequired = true;
                        }

                        if (this.nextStep === "validate-password-pii") {
                            this.passwordRequired = false;
                        }

                        this.nextAPI = factor._links.validatePii.href;

                        if (this.skipCollection) {
                            this.routeNextStep();
                        }
                        else {
                            this.init = false;
                            this.isValid = false;
                        }
                    }

                    this.$emitter.emit('stop-loading','validate-pii');
                }.bind(this));
            },

            routeNextStep: function() {
                if (this.nextStep === "newUser") {
                    this.goToNewUser();
                }
                else if (this.nextStep === "validate-password-pii") {
                    this.validatePasswordPii();
                }
                else if (this.nextStep === "validate-login-pii") {
                    this.validateLoginPii();
                }
                else if (this.nextStep === "validate-username-pii") {
                    this.validateUsernamePii();
                }
            },

            goToNewUser: function() {                
                var data = {
                    createAPI: this.nextAPI,
                    tinType: this.tinType,
                    taxId: this.taxIdNumber,
                    accountRequired: this.accountRequired,
                    dateOfBirthRequired: this.dateOfBirthRequired,
                    stateToken: this.stateToken
                };
                this.$emitter.emit('navigate', { componentName: this.nextStep, routeData: data });
            },

            validatePasswordPii: function() {
                this.$emitter.emit('start-loading', 'validate-password-pii');
                var data = {
                    cwUserIdMaint: {
                        taxIdFormatCode: this.tinType,
                        taxId: this.taxIdNumber,
                        userId: this.username
                    },
                    devicePrint: encode_deviceprint(),
                    stateToken: this.stateToken,
                    profileCallerId: this.profileCallerId
                };

                if (this.accountRequired) {
                    data.cwUserIdMaint.accountNumber = this.accountNumber;
                }

                if (this.dateOfBirthRequired) {
                    data.cwUserIdMaint.customerBirthDate = this.dateOfBirth;
                }

                this.$axios.post(this.nextAPI, data).then(function(response) {
                    if (response.data.success) {
                        var passwordData = {
                            tinType: this.tinType,
                            taxId: this.taxIdNumber,
                            accountNumber: this.accountNumber,
                            dateOfBirth: this.dateOfBirth,
                            userId: this.username
                        };
                        this.$emitter.emit('set-pii-password-data', passwordData);

                        var nextScreenData = {
                            stateToken: response.data.data.stateToken
                        };

                        var nextScreen = "";
                        if (response.data.data.status === "MFA_REQUIRED") {                            
                            nextScreenData.flow = this.flow;
                            nextScreenData.methods = response.data.data._embedded.factors;
                            nextScreenData.cancelUrl = response.data.data._links.cancel.href;
                            nextScreen = "mfaSelect";
                        }
                        else if (response.data.data.status === "PASSWORD_RESET") {
                            nextScreenData.api = response.data.data._links.next.next.href;
                            nextScreen = "resetPassword";
                        }

                        this.$emitter.emit('navigate', { componentName: nextScreen, routeData: nextScreenData });
                        this.$emitter.emit('stop-loading', 'validate-password-pii');
                    }
                }.bind(this)).catch(function(error){
                    var errorData = {
                        error: {
                            errorCode: error.response.data.messages[0].errorCode,
                            errorMessage: error.response.data.messages[0].errorMessage,
                            errorType: error.response.data.messages[0].errorType
                        }
                    };
                    this.$emitter.emit('reprofileThreatMatrics');
                    //this.goToIndexPage();
                    this.$emitter.emit('navigate', { componentName: 'login', routeData: errorData });
                    this.$emitter.emit('stop-loading', 'validate-password-pii');
                }.bind(this));
            },

            validateUsernamePii: function() {
                this.$emitter.emit('start-loading', 'validate-username-pii');
                var data = {
                    cwUserIdMaint: {
                        taxIdFormatCode: this.tinType,
                        taxId: this.taxIdNumber,
                        password: this.password
                    },
                    devicePrint: encode_deviceprint(),
                    stateToken: this.stateToken,
                    profileCallerId: this.profileCallerId
                };

                if (this.accountRequired) {
                    data.cwUserIdMaint.accountNumber = this.accountNumber;
                }

                if (this.dateOfBirthRequired) {
                    data.cwUserIdMaint.customerBirthDate = this.dateOfBirth;
                }

                this.$axios.post(this.nextAPI, data).then(function(response) {
                    if (response.data.success) {

                        var nextScreenData = {};

                        var nextScreen = "";
                        if (response.data.data.status === "MFA_REQUIRED") { 
                            nextScreenData.stateToken = response.data.data.stateToken                           
                            nextScreenData.flow = this.flow;
                            nextScreenData.methods = response.data.data._embedded.factors;
                            nextScreenData.cancelUrl = response.data.data._links.cancel.href;
                            nextScreen = "mfaSelect";
                        }
                        else if (response.data.data.status === "MFA_ENROLL") {                            
                            nextScreenData.nextObj = {
                                flow: this.flow,
                                stateToken: response.data.data.stateToken,
                                addAPI: response.data.data._links.next.href
                            };
                            nextScreenData.userId = response.data.data.userId;
                            nextScreen = "retrieveUser";
                        }
                        else if (response.data.data.status === "RETRIEVE_USER") {
                            nextScreenData.userId = response.data.data.userId;
                            nextScreenData.links = response.data.data._links;
                            nextScreen = "retrieveUser";
                        }

                        this.$emitter.emit('navigate', { componentName: nextScreen, routeData: nextScreenData});
                        this.$emitter.emit('stop-loading', 'validate-username-pii');
                    }
                }.bind(this)).catch(function(error) {
                    var errorData = {
                        error: {
                            errorCode: error.response.data.messages[0].errorCode,
                            errorMessage: error.response.data.messages[0].errorMessage,
                            errorType: error.response.data.messages[0].errorType
                        }
                    };
                    this.$emitter.emit('reprofileThreatMatrics');
                    //this.goToIndexPage();
                    this.$emitter.emit('navigate', { componentName: 'login', routeData: errorData});
                    this.$emitter.emit('stop-loading', 'validate-username-pii');
                }.bind(this));
            },

            validateLoginPii: function() {
                this.$emitter.emit('start-loading', 'validate-login-pii');
                var data = {
                    cwUserIdMaint: {
                        taxIdFormatCode: this.tinType,
                        taxId: this.taxIdNumber
                    },
                    devicePrint: encode_deviceprint(),
                    stateToken: this.stateToken,
                    skipMfaEnrollment: this.skipMfaEnrollment,
                    profileCallerId: this.profileCallerId
                };

                if (this.accountRequired) {
                    data.cwUserIdMaint.accountNumber = this.accountNumber;
                }

                if (this.dateOfBirthRequired) {
                    data.cwUserIdMaint.customerBirthDate = this.dateOfBirth;
                }

                this.$axios.post(this.validateAPI, data).then(function(response) {
                    if (response.data.success) {
                        if (response.data.data.status === "MFA_ENROLL") {
                            var data = {
                                flow: this.flow,
                                stateToken: response.data.data.stateToken,
                                addAPI: response.data.data._links.next.href
                            };

                            this.$emitter.emit('navigate', { componentName: 'mfaEnroll', routeData: data});
                            this.$emitter.emit('stop-loading', 'validate-login-pii');
                        }
                        else if (response.data.data.status === "SUCCESS") {
                            this.start(response.data.data._links);
                        }
                    }
                }.bind(this)).catch(function(error) {
                    var errorData = {
                        error: {
                            errorCode: error.response.data.messages[0].errorCode,
                            errorMessage: error.response.data.messages[0].errorMessage,
                            errorType: error.response.data.messages[0].errorType
                        }
                    };
                    this.$emitter.emit('reprofileThreatMatrics');
                    this.$emitter.emit('navigate', { componentName: 'login', routeData: errorData});
                    this.$emitter.emit('stop-loading', 'validate-login-pii');
                }.bind(this));
            },

            cancel: function() {
                this.$emitter.emit('start-loading', 'cancel-pii');
                window.location.href = window.location.href;
            },

            setTaxId: function(val) {
                this.taxIdNumber = val;
            },

            setAccountNumber: function(val) {
                this.accountNumber = val;
            },

            setDateOfBirth: function(val) {
                this.dateOfBirth = val;
            },

            setPassword: function(val) {
                this.password = val;
            },

            setAccountNumberFocus: function() {
                if(this.init) return;
                setTimeout(() => this.$refs.accountNumber.setFocus(), 200);
            }
        },

        watch: {
            init: function(val) {
                nextTick(() => this.setAccountNumberFocus());

                if (val) {
                    this.$emitter.emit('hide', this.nextStep);
                    this.$emitter.emit('show','validate-pii');
                }
                else {
                    this.$emitter.emit('hide','validate-pii');
                    this.$emitter.emit('show', this.nextStep);
                }
            },

            accountNumber: function(val) {
                if (val === "") {
                    this.isValid = false;
                }
                else {
                    if (this.taxIdNumber !== "" && (this.dateOfBirth !== "" || !this.dateOfBirthRequired) && (this.password !== "" || !this.passwordRequired)) {
                        this.isValid = true;
                    }
                }
            },

            dateOfBirth: function(val) {                
                if (val === "") {
                    this.isValid = false;
                }
                else {
                    if (this.taxIdNumber !== "" && (this.accountNumber !== "" || !this.accountRequired) && (this.password !== "" || !this.passwordRequired)) {
                        this.isValid = true;
                    }
                }
            },

            taxIdNumber: function(val) {
                if (val != "") {
                    if (this.init) {
                        this.isValid = true;
                    }
                    else {
                        if ((this.accountNumber !== "" || !this.accountRequired) && (this.dateOfBirth !== "" || !this.dateOfBirthRequired)) {
                            this.isValid = true;
                        }
                    }
                }
                else {
                    this.isValid = false;
                }
            },

            password: function(val) {
                if (val === "") {
                    this.isValid = false;
                }
                else {
                    if ((this.accountNumber !== "" || !this.accountRequired) && (this.dateOfBirth !== "" || !this.dateOfBirthRequired)) {
                        this.isValid = true;
                    }
                }
            },

            isValid: function(val) {
                if (val) {
                    if (this.init) {
                        this.$emitter.emit('enable', 'validate-pii');
                    }
                    else {
                        this.$emitter.emit('enable', this.nextStep);
                    }
                }
                else {
                    if (this.init) {
                        this.$emitter.emit('disable', 'validate-pii');
                    }
                    else {
                        this.$emitter.emit('disable', this.nextStep);
                    }
                }
            }
        },

        mounted: function(){
            this.setAccountNumberFocus();
        }
    }
</script>